import { render, staticRenderFns } from "./ComplaintManagerInfo.vue?vue&type=template&id=6b38fcbb&"
import script from "./ComplaintManagerInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintManagerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports